
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ChangeLanguageIconSp from '@/components/ChangeLanguageIconSp.vue';
import ChangeLanguageIconPc from '@/components/ChangeLanguageIconPc.vue';

@Component({
  components: { ChangeLanguageIconSp, ChangeLanguageIconPc }
})
export default class PageHeader extends Vue {
  @Prop({ type: Boolean, default: false })
  displayLanguageIcon!: boolean;

  private get isOpDocPage(): boolean {
    return this.$store.getters['camera/isOpdoc'];
  }

  private get isGpDocPage(): boolean {
    return this.$store.getters['camera/isGpdoc'];
  }

  public mounted(): void {
    if (!this.isOpDocPage && !this.isGpDocPage) this.fixHeaderTitleStyleByLineCount();
  }

  // テキストが二行以上ならpaddingを解除して左寄せにする
  private fixHeaderTitleStyleByLineCount(): void {
    const headerTitle = this.$refs.headerTitle as HTMLElement;
    const headerTitleSlot = this.$refs.headerTitleSlot as HTMLElement;
    if (headerTitle && headerTitleSlot) {
      const headerTitleSlotHeight = headerTitleSlot.clientHeight;
      const headerTitleSlotLineHeight = Math.round(parseFloat(window.getComputedStyle(headerTitleSlot).lineHeight));
      if (headerTitleSlotHeight > headerTitleSlotLineHeight) {
        if (!this.$store.getters['camera/isPC']) headerTitle.style.paddingLeft = '20px';
        headerTitle.style.justifyContent = 'flex-start';
      } else {
        headerTitle.style.paddingLeft = '';
        headerTitle.style.justifyContent = '';
      }
    }
  }

  @Watch('$i18n.locale')
  private onTitleChanged(locale: string): void {
    this.$nextTick(() => {
      this.fixHeaderTitleStyleByLineCount();
    });
  }
}
